import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import Main from '../views/Main.vue';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: Main,
    meta: {
      title: 'Roos Netjes Voice-Over',
    },
  },
  {
    path: '/over-roos',
    name: 'OverRoos',
    meta: {
      title: 'Over Roos Voice-Over',
    },
    component: () => import('../views/OverRoos.vue'),
  },
];

const router = new VueRouter({
  routes,
  scrollBehavior(to) {
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: 'smooth',
      };
    }
    return { x: 0, y: 0 };
  },
});

// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
  // This goes through the matched routes from last to first, finding the closest route
  // with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles,
  // nested's will be chosen.
  const nearestWithTitle = to.matched.slice().reverse()
    .find((r) => r.meta && r.meta.title);

  // // Find the nearest route element with meta tags.
  // const nearestWithMeta = to.matched.slice().reverse()
  //   .find(r => r.meta && r.meta.metaTags);
  // const previousNearestWithMeta = from.matched.slice().reverse()
  //   .find(r => r.meta && r.meta.metaTags);

  // If a route with a title was found, set the document (page) title to that value.
  if (nearestWithTitle) {
    document.title = nearestWithTitle.meta.title;
  }

  // // Remove any stale meta tags from the document using the key attribute we set below.
  // Array.from(document.querySelectorAll('[data-vue-router-controlled]'))
  //   // @ts-ignore
  //   .map(el => el.parentNode.removeChild(el));
  //
  // // Skip rendering meta tags if there are none.
  // if (!nearestWithMeta) return next();
  //
  // // Turn the meta tag definitions into actual elements in the head.
  // nearestWithMeta.meta.metaTags.map((tagDef: { [x: string]: string; }) => {
  //   const tag = document.createElement('meta');
  //
  //   Object.keys(tagDef).forEach(key => {
  //     tag.setAttribute(key, tagDef[key]);
  //   });
  //
  //   // We use this to track which meta tags we create, so we don't interfere with other ones.
  //   tag.setAttribute('data-vue-router-controlled', '');
  //
  //   return tag;
  // })
  //   // Add the meta tags to the document head.
  //   .forEach((tag: any) => document.head.appendChild(tag));

  next();
});

export default router;
